import { useMemo } from 'react'
import Button from '../Button'
import LoadingSpinner from '../../uiV2/common/loading/LoadingSpinner'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { HelixCandidateLiteDto } from '../../api/role/models/CandidateDto'
import { useManageCandidateStore } from '../manageRole/stateStore/manageCandidateStore'
import {
    buildCandidatePresentMap,
    getCandidatesNeedingSave,
} from '../../utils/candidateUtils'

type Props = {
    helixCandidateLiteDtos: HelixCandidateLiteDto[]
    isSavingAllCandidates: boolean
    onSaveAllCandidates: () => void
}

export default function SaveAllToRoleButton({
    helixCandidateLiteDtos,
    isSavingAllCandidates,
    onSaveAllCandidates,
}: Props) {
    const storeCandidates = useManageCandidateStore((s) => s.candidates)
    const ephemeralCandidates = useManageCandidateStore(
        (s) => s.ephemeralCandidates,
    )

    const hasCandidatesNeedingSave = useMemo(() => {
        const candidatePresentById = buildCandidatePresentMap(
            storeCandidates,
            ephemeralCandidates,
        )

        return (
            getCandidatesNeedingSave(
                helixCandidateLiteDtos,
                candidatePresentById,
            ).length > 0
        )
    }, [helixCandidateLiteDtos, storeCandidates, ephemeralCandidates])

    return (
        <Button
            type="button"
            style="secondary"
            size="small"
            onClick={onSaveAllCandidates}
            enabled={!isSavingAllCandidates && hasCandidatesNeedingSave}
        >
            {isSavingAllCandidates ? (
                <LoadingSpinner spinnerSize={18} />
            ) : (
                <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
            )}
            {isSavingAllCandidates ? 'Saving...' : 'Save all to role'}
        </Button>
    )
}
